import React from 'react';
import { Box, Select } from "@amzn/awsui-components-react";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import { Stage } from "../../../lusca-search-api/generated-src";

interface StageSelectorProps {
  stage: Stage;
  setStage: (stage: Stage) => void;
}

export const StageSelector: React.FC<StageSelectorProps> = ({
  stage,
  setStage
}) => {
  return (
    <SpaceBetween size="xs">
      <Box>Environment</Box>
      <Select
        selectedOption={{ label: stage, value: stage }}
        onChange={({ detail }) => {
          const newStage = detail.selectedOption.value as Stage || stage;
          setStage(newStage);
        }}
        options={[
          { label: Stage.Prod, value: Stage.Prod },
          { label: Stage.Gamma, value: Stage.Gamma },
          { label: Stage.Beta, value: Stage.Beta },
        ]}
        selectedAriaLabel="Selected"
        placeholder="Select a stage"
        ariaRequired={true}
      />
    </SpaceBetween>
  );
};
